export const enAuthI18n: any = {
  "Given Name": "First Name",
};
